// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3pXaX","amount":"Amount_amount__2zadn","tip":"Amount_tip__3J3Gz","tipHeader":"Amount_tipHeader__3_6UI","tipsWrap":"Amount_tipsWrap__1hylV"};